import React from "react";

import Wrapper from "./Wrapper";
import FormWrapper from "./FormWrapper";
import { ArrowDown, ArrowUp } from "../../../Arrows";
import Form from "../../Properties/Form";
import FormContext from "../../Properties/Form/FormContext";

class Class extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = { open: true };
  }

  toggle() {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  }

  render() {
    const { type, ...props } = this.props;
    const Arrow = this.state.open ? ArrowUp : ArrowDown;

    return (
      <React.Fragment>
        <Wrapper>
          <input type="radio" />New or <input type="radio" />Select existing{" "}
          <select /> <a href="#">edit</a>
          <Arrow onClick={this.toggle} />
        </Wrapper>
        <FormWrapper open={this.state.open}>
          <FormContext.Consumer>
            {context => <Form {...context} selected={[type]} {...props} />}
          </FormContext.Consumer>
        </FormWrapper>
      </React.Fragment>
    );
  }
}

export default Class;
